



































import { Vue, Component } from 'vue-property-decorator';
import { required, email } from 'vuelidate/lib/validators';
import { routeTo } from '@/api/reactor/reactions';

@Component({
    validations: {
        form: {
            name: {
                required,
                email
            },
        }
    },
    reactions: {
      '$users/userCreated': routeTo((ctx) => {
          return { name: 'users', params: ctx.$route.params};
      })
    }
})
export default class UserForm extends Vue {
  form: any = {
    destinationId: '',
    name: ''
  };
  loading: boolean = false;

  get nameErrors () {
    const errors: any[] = [];
    if (this.$v && this.$v.form && this.$v.form.name) {
      if (!this.$v.form.name.$dirty) return errors;
      !this.$v.form.name.required && errors.push('Email Address is required.');
      !this.$v.form.name.email && errors.push('Need a valid email.');
    }
    return errors
  }
  
  async mounted() {
    await this.$store.dispatch('$destinations/select', this.$route.params.did);
    this.form.destinationId = this.$route.params.did;
  }

  async onSubmit() {
    this.loading = true;
    await this.$store.dispatch('$users/create', this.form);
    this.loading = false;
  }
}
